import {
  Tv,
  Layers,
  MonitorPlay,
  Sparkles,
  AlignVerticalSpaceBetween,
  Lightbulb,
  Gem,
  BookOpen,
} from "lucide-react";
import { SERVICES } from "../data/site";
import { useReveal } from "../hooks/useReveal";
import FlyWords from "./FlyWords";

const ICONS = {
  Tv,
  Layers,
  MonitorPlay,
  Sparkles,
  AlignVerticalSpaceBetween,
  Lightbulb,
  Gem,
  BookOpen,
};

export default function Services() {
  const ref = useReveal();
  return (
    <section
      id="services"
      data-testid="services-section"
      className="section bg-[#050505] relative"
      ref={ref}
    >
      <div className="container-x">
        <div className="max-w-3xl mb-16 reveal">
          <div className="overline mb-5">What we build</div>
          <FlyWords
            as="h2"
            className="font-display text-4xl md:text-5xl lg:text-6xl text-white font-light leading-tight"
            segments={[
              { text: "Architectural focal points," },
              { type: "break" },
              { text: "built to impress.", className: "italic text-[#D4AF37]" },
            ]}
          />
          <p className="mt-6 text-base md:text-lg text-[#A1A1AA] max-w-2xl">
            From floating media walls to backlit stone features — every project
            is engineered around your space, lifestyle and aesthetic.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {SERVICES.map((s, i) => {
            const Icon = ICONS[s.icon] || Sparkles;
            return (
              <div
                key={s.key}
                data-testid={`service-card-${s.key}`}
                className="surface p-7 md:p-8 reveal"
                style={{ transitionDelay: `${i * 60}ms` }}
              >
                <div className="h-11 w-11 rounded-full border border-[#27272A] flex items-center justify-center mb-6 text-[#D4AF37]">
                  <Icon className="h-5 w-5" />
                </div>
                <h3 className="font-display text-2xl text-white mb-3">{s.title}</h3>
                <p className="text-sm text-[#A1A1AA] leading-relaxed">{s.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
